import { render, staticRenderFns } from "./delectHc.vue?vue&type=template&id=42f45c8c&scoped=true&"
import script from "./delectHc.vue?vue&type=script&lang=js&"
export * from "./delectHc.vue?vue&type=script&lang=js&"
import style0 from "./delectHc.vue?vue&type=style&index=0&id=42f45c8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f45c8c",
  null
  
)

export default component.exports